<template>
    <div 
        class="visualiser-main"
        :style="{
            '--builder-top': this.builderBox.top!==null ? this.builderBox.top + 'px' : null,
            '--builder-left': this.builderBox.left!==null ? this.builderBox.left + 'px' : null,
            '--builder-bottom': this.builderBox.bottom!==null ? this.builderBox.bottom + 'px' : null,
            '--builder-width': this.builderBox.width!==null ? this.builderBox.width + 'px' : null
        }" 
    >
        <div class="container">
            <div class="breadcrumb">
                <a :href="backNavigationLink">
                    <span class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <mask id="mask0_1226_20954" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_1226_20954)">
                                <path d="M6.92115 12.5L12.7135 18.2923L12 19L5 12L12 5L12.7135 5.7077L6.92115 11.5H19V12.5H6.92115Z" fill="#1C1B1F"/>
                            </g>
                        </svg>
                    </span>

                    Back to home selector
                </a>
            </div>

            <div v-if="data.headerTitle || data.headerDescription" class="header">
                <h1 v-if="data.headerTitle" class="no--margin">
                    {{data.headerTitle}}
                </h1>
                <p v-if="data.headerDescription" class="no--margin">
                    {{data.headerDescription}}
                </p>
            </div>

            <div class="label-wrapper">
                <div class="label">
                    <div>
                        <h2 class="label--title">
                            {{currentTitle}}
                        </h2>
                        <p class="label--summary">
                            {{currentSummary}}
                        </p>
                    </div>
                    <div v-html="currentContent" class="wysiwyg-content text-center no--margin"></div>
                </div>
            </div>

            <div class="builder">
                <div class="builder-preview-mobile">
                    <img @load="onImgLoad" v-if="currentAsset" :src="currentAsset" class="" alt="">
                    <img @load="onImgLoad" v-else :src="data.image" class="" alt="">
                    
                    <div class="fav-wrapper">
                        <div
                            class="fav add-fav"
                            :data_id="moodboardID"
                            :class="isFavorite"
                            @click="addFav(moodboardID)"
                            data-category="MoodBoard"
                            data-action="Click"
                            data-label="Heart"
                        >
                            <span class="tooltipinfo">Add to Moodboard</span>
                        </div>
                        <div
                            class="fav remove-fav"
                            :data_id="moodboardID"
                            :class="isFavorite"
                            @click="removeFav(moodboardID)"
                            data-category="MoodBoard"
                            data-action="Click"
                            data-label="Heart"
                        >
                            <span class="tooltipinfo">Remove from Moodboard</span>
                        </div>
                    </div>
                </div>
                
                <div class="builder-select" :class="builderBox.wrapperClass">
                    <div class="builder-select--sizer" ref="builderAnchor"></div>
                    <div class="builder-select--inner" :class="builderBox.class">
                        <!-- <pre>data.options:{{data.options}} </pre> -->
                        <accordion class="accordion--small">
                            <template v-for="(option, accordionIndex) in data.options" :key="accordionIndex">
                                <accordion-item v-if="option.itemsExist" @openTriggered="resizeHandler">
                                    <template v-slot:accordion-title slot="accordion-title">
                                        <p class="accordion-title">
                                            {{option.title}}
                                        </p>
                                        <p v-if="option.description" class="accordion-description">
                                            {{option.description}}
                                        </p>
                                    </template>
                                    
                                    <template v-slot:accordion-content slot="accordion-content" >

                                        <div 
                                            v-if="option.colour"
                                            class="selections" 
                                            :class="['section-colour', option.type]"
                                        >
                                            <template v-if="option.groups">
                                                <!-- add min and max class here -->
                                                <div class="color-option-wrapper">
                                                    <div class="filter-wrapper--hide-scroll">
                                                        <div
                                                            :id="`filter-wrapper-${accordionIndex}-${groupIndex}`"
                                                            class="color-option-scroll"
                                                            @scroll="slideOnScroll(`filter-wrapper-${accordionIndex}-${groupIndex}`)"
                                                        >
                                                            <div class="items">
                                                                <template v-for="(group, groupIndex) in option.groups"  :key="groupIndex">
                                                                    <a 
                                                                        v-for="(item, groupChildrenIndex) in group.children" 
                                                                        :data-debug-test="(typeof item)"
                                                                        :data-debug-exists="(item.colour.exists)"
                                                                        :key="groupChildrenIndex"  
                                                                        @click="getData(currentHouseID,item.type, item.slug)" 
                                                                        
                                                                        @mouseover="checkPosition"
            
                                                                        :data-id="item.id" 
                                                                        :data-slug="item.slug" 
                                                                        :data-type="item.type" 
                                                                        class="color option"
                                                                    >
                                                                        <colour-card
                                                                            v-if="item.colour"
                                                                            :data="item.colour"
                                                                            :isShowLabelOnHover="false"
                                                                        />
                                                                        
                                                                        <label class="color-name">
                                                                            <span>
                                                                                {{ replaceString(item.colour.hovername, replaceString(group.title, 'Range', ''), '') }}
                                                                            </span>
                                                                        </label>
                                                                        <div class="color-group">
                                                                            <span>
                                                                                -{{ replaceString(group.title, 'Range', '') }}-
                                                                            </span>
                                                                        </div>
                                                                    </a>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <button class="filter-wrapper--prev" @click="slidePrev(`filter-wrapper-${accordionIndex}-${groupIndex}`)">
                                                        <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                                        </svg>
                                                    </button>

                                                    <button class="filter-wrapper--next" @click="slideNext(`filter-wrapper-${accordionIndex}-${groupIndex}`)">
                                                        <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </template>

                                            <template v-else>
                                                <div class="color-option-wrapper">
                                                    <div class="filter-wrapper--hide-scroll">
                                                        <div
                                                            :id="`filter-wrapper-${accordionIndex}`"
                                                            class="color-option-scroll"
                                                            @scroll="slideOnScroll(`filter-wrapper-${accordionIndex}`)"
                                                        >
                                                            <div class="items">
                                                                <a
                                                                    v-for="(item, itemIndex) in option.items" 
                                                                    :key="itemIndex"  
                                                                    @click="getData(currentHouseID,item.type, item.slug)" 
        
                                                                    @mouseover="checkPosition"
                                                                    
                                                                    :data-id="item.id" 
                                                                    :data-slug="item.slug" 
                                                                    :data-type="item.type" 
                                                                    class="color option"
                                                                >
                                                                    <colour-card
                                                                        v-if="item.colour"
                                                                        :data="item.colour"
                                                                        :isShowLabelOnHover="false"
                                                                    />

                                                                    <label class="color-name">
                                                                        <span>
                                                                            {{ item.colour.hovername }}
                                                                        </span>
                                                                    </label>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <button class="filter-wrapper--prev" @click="slidePrev(`filter-wrapper-${accordionIndex}`)">
                                                        <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                                        </svg>
                                                    </button>

                                                    <button class="filter-wrapper--next" @click="slideNext(`filter-wrapper-${accordionIndex}`)">
                                                        <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </template>
                                        </div>

                                        <div 
                                            v-else
                                            class="selections" 
                                            :class="option.type"
                                        >
                                            <a v-for="(item, index) in option.items" :key="index"  @click="getData(currentHouseID,item.type, item.slug)" :id="item.id" :data-id="item.id"  :data-type="item.type" :data-slug="item.slug" class="option hover">
                                                <div class="icon card"><img :src="item.icon" :alt="item.title" style="max-width: 100%;"></div>
                                                <div class="hovertitle">{{item.hovertitle}}</div>
                                            </a>
                                        </div>

                                    </template>
                                </accordion-item>
                            </template>
                        </accordion>
                    </div>

                </div>
                <div class="builder-display" ref="builderDisplay">
                    <div class="preview">
                        <img @load="onImgLoad" v-if="currentAsset" :src="currentAsset" class="" alt="">
                        <!-- <img v-else src="_resources/themes/colorsteel/dist/assets/images/visualiser/develop/placeholder.jpg" class="" alt=""> -->
                        <img @load="onImgLoad" v-else :src="data.image" class="" alt="">

                        <div class="fav-wrapper">
                            <div
                                class="fav add-fav"
                                :data_id="moodboardID"
                                :class="isFavorite"
                                @click="addFav(moodboardID)"
                                data-category="MoodBoard"
                                data-action="Click"
                                data-label="Heart"
                            >
                                <span class="tooltipinfo">Add to Moodboard</span>
                            </div>
                            <div
                                class="fav remove-fav"
                                :data_id="moodboardID"
                                :class="isFavorite"
                                @click="removeFav(moodboardID)"
                                data-category="MoodBoard"
                                data-action="Click"
                                data-label="Heart"
                            >
                                <span class="tooltipinfo">Remove from Moodboard</span>
                            </div>
                        </div>
                    </div>

                    <div class="action-wrapper">
                        <div class="action-block" v-if="data.orderSampleTitle || data.orderSampleDescription || (data.orderSampleCta && data.orderSampleCta.label)">
                            <h2 v-if="data.orderSampleTitle" class="no--margin">
                                {{data.orderSampleTitle}}
                            </h2>
                            <p v-if="data.orderSampleDescription" class="no--margin">
                                {{data.orderSampleDescription}}
                            </p>
                            <a
                                v-if="data.orderSampleCta && data.orderSampleCta.label"
                                class="button button--solid-black no--margin"
                                :href="`${data.orderSampleCta.link}?houseID=${currentHouseID}`"
                                :target="data.orderSampleCta.openInNewWindow ? '_blank' : null"
                                data-category="Roof Visualiser" data-action="Click" :data-label="data.orderSampleCta.label"
                            >
                                {{ data.orderSampleCta.label }}
                            </a>
                        </div>
                        <div class="action-block" v-if="data.shareTitle || data.shareDescription">
                            <h2 v-if="data.shareTitle" class="no--margin">
                                {{data.shareTitle}}
                            </h2>
                            <p v-if="data.shareDescription" class="no--margin">
                                {{data.shareDescription}}
                            </p>
                            <div class="action-share">
                                <a
                                    @click="copyShare"
                                    class="button button--solid-black no--margin"
                                    aria-label="Copy share"
                                    data-category="Roof Visualiser"
                                    data-action="Click"
                                    data-label="Copy Share Link"
                                >
                                    Copy this link
                                </a>
                                <a
                                    @click="emailShare"
                                    class="button button--clear-black no--margin"
                                    aria-label="Copy share"
                                    data-category="Roof Visualiser"
                                    data-action="Click"
                                    data-label="Share Email"
                                >
                                    Send link by email
                                </a>
                            </div>
                        </div>
                        <div class="action-block" v-if="data.moodboardTitle || data.moodboardDescription || (data.moodboardCta && data.moodboardCta.label)">
                            <h2 v-if="data.moodboardTitle" class="no--margin">
                                {{data.moodboardTitle}}
                            </h2>
                            <div v-if="data.moodboardDescription" v-html="data.moodboardDescription" class="wysiwyg-content"></div>
                            <a
                                v-if="data.moodboardCta && data.moodboardCta.label"
                                class="button button--clear-black no--margin"
                                :href="data.moodboardCta.link"
                                :target="data.moodboardCta.openInNewWindow ? '_blank' : null"
                                data-category="Roof Visualiser" data-action="Click" :data-label="data.moodboardCta.label"
                            >
                                {{ data.moodboardCta.label }}
                            </a>
                        </div>
                    </div>

                    <div class="builder-select--sizer" ref="builderDisplayAnchor"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

import Accordion from "../components/Accordions/Accordion";
import AccordionItem from "../components/Accordions/AccordionItem";
import ColourCard from "../components/Cards/ColourCard";
import { notify } from "@kyvg/vue3-notification";
import { ModalShare } from "../components";

import { debounce } from 'vue-debounce'

export default {
    name: "v-visualiser",
    components: {
        Accordion,
        AccordionItem,
        ColourCard,
        ModalShare,
        // Fragment
    },
    props: {
        data: {
            type: Object
        },
        backNavigationLink: {
            type: String
        },
    },
    data () {
        return {
            isFavorite: false,
            moodboards: [],
            moodboardID:null,
            disabledData:{},
            avaliableData:{},
            responseData:{},
            currentAsset:'',
            currentAssetID: '',
            currentTitle: '',
            currentSummary: '',
            currentContent: '',
            currentHouseID: '',
            currentProfile: '',
            currentRoofColour: '',
            currentHouseColour: '',
            currentTrimColour: '',
            currentAvaliableOptions: '',
            builderBox: {
                top: null,
                left: null,
                width: null,
                bottom: null,
                class: '',
                wrapperClass: ''
            },
            intervalID: 0,
        }
    },
    methods: {
        replaceString(text, search, replacement) {
            if (!text) return '';

            return text.replace(search, replacement).trim();
        },
        checkPosition (ev) {
            let target = ev.target.tagName==='DIV' ? ev.target : ev.target.querySelector(".colour-card");
            if(target.classList.value.includes('colour-circle')){
                target = ev.target.closest('.colour-card');
            }
            
            let rect = this.$refs.builderAnchor.getBoundingClientRect();
            let itemRect = target.getBoundingClientRect();
            let innerLeft = itemRect.left - rect.left;
            const offset = 150;
            let limit = rect.width - offset;
        
            let location = 'left';
            if(innerLeft>limit){
                target.classList.add('right-side');
                location = 'right';
            }else{
                target.classList.remove('right-side');
            }
        },
        setIsFavorite(imageId) {
            if (this.moodboards?.length > 0) {
                const isMatch = this.moodboards.some(item => {
                    return imageId === item.houseId;
                });

                if (isMatch && !this.isFavorite) {
                    this.toggleFavStyle('added');
                } else if (!isMatch && this.isFavorite) {
                    this.toggleFavStyle('removed');
                }
            }
        },
        toggleFavStyle(state) {
            if (state === 'added') {
                const e1List = this.$el.querySelectorAll(".add-fav");
                const e2List = this.$el.querySelectorAll(".remove-fav");

                e2List.forEach(e2 => {
                    e2.classList.add('d-block');
                    e2.classList.add('opacity-none');

                    setTimeout(() => {
                        e2.classList.add('opacity-one');
                        e2.classList.remove('opacity-none');
                    }, 25);

                    setTimeout(() => {
                        e2.classList.add('selected');
                        e2.classList.remove('d-block');
                        e2.classList.remove('opacity-one');
                    }, 275);
                });

                e1List.forEach(e1 => {
                    setTimeout(() => {
                        e1.classList.add('selected');
                    }, 275);
                });

                this.isFavorite = true;
            } else if (state === 'removed') {
                const e1List = this.$el.querySelectorAll(".add-fav");
                const e2List = this.$el.querySelectorAll(".remove-fav");

                let hasRemove = false;

                e2List.forEach(e2 => {
                    const classStr = e2.className;
                    hasRemove = classStr.includes("fav remove-fav selected remove");

                    if (hasRemove) {
                        e2.classList.add('fade-out');
                    }

                    e2.classList.add('d-block');
                    e2.classList.add('opacity-one');

                    setTimeout(() => {
                        e2.classList.add('opacity-none');
                        e2.classList.remove('opacity-one');
                    }, 25);

                    setTimeout(() => {
                        e2.classList.remove('selected');
                        e2.classList.remove('opacity-one');
                        e2.classList.remove('d-block');
                    }, 275);
                });

                e1List.forEach(e1 => {
                    e1.classList.remove('selected');
                });

                this.isFavorite = false;
            }
        },
        addFav (id) {
            this.toggleFavStyle('added');
            axios.get(`/moodboardapi/item/${id}/toggle/?${Date.now()}`)
                .then(response => {
                    let message = {
                        title: 'Item added to moodboard',
                        text: 'Item added to moodboard',
                    }

                    notify(message);
                    this.appendtoNotification(message);
                })
                .catch(error => {
                    console.log(error);
                })
        },
        removeFav (id) {
            this.toggleFavStyle('removed');
            axios.get(`/moodboardapi/item/${id}/toggle/?${Date.now()}`)
                .then(response => {
                    const message = {
                        title: 'Item removed from moodboard',
                        text: 'Item removed from moodboard',
                    };

                    notify(message);
                    this.appendtoNotification(message);
                })
                .catch(error => {
                    console.log(error);
                })
        },
        setOptions(){
            var options = this.currentAvaliableOptions;
            var avaliablehousecolours = options.housecolours;
            var avaliableroofcolours = options.roofcolours;
            var avaliabletrimcolours = options.trimcolours;
            var avaliableprofiles = options.profiles;


            // profiles
            var profilesHolder = this.$el.querySelector(".profiles-holder");
            var profilesHolderOptions = this.$el.querySelectorAll(".profiles-holder .option");
            var parsedavaliableprofiles = JSON.parse(JSON.stringify(avaliableprofiles))
        
            for (let i = 0; i < profilesHolderOptions.length; i++) {
                var id = profilesHolderOptions[i].getAttribute('data-id');
                if(parsedavaliableprofiles.hasOwnProperty(id)){
                    profilesHolderOptions[i].classList.remove('disabled');
                }else{
                    profilesHolderOptions[i].classList.add('disabled');
                }
                
            }

            // roof-colours
            var roofColoursHolder = this.$el.querySelector(".roof-colours-holder");
            var roofColoursHolderOptions = this.$el.querySelectorAll(".roof-colours-holder .option");
            var parsedavaliableroofcolours = JSON.parse(JSON.stringify(avaliableroofcolours))
        
            for (let i = 0; i < roofColoursHolderOptions.length; i++) {
                // roofColoursHolderOptions[i].classList.add('disabled');
                var id = roofColoursHolderOptions[i].getAttribute('data-id');
                if(parsedavaliableroofcolours.hasOwnProperty(id)){
                    roofColoursHolderOptions[i].classList.remove('disabled');
                }else{
                    roofColoursHolderOptions[i].classList.add('disabled');
                }
            }


            // house-colours
            var houseColoursHolder = this.$el.querySelector(".house-colours-holder");
            var houseColoursHolderOptions = this.$el.querySelectorAll(".house-colours-holder .option");
            var parsedavavaliablehousecolours = JSON.parse(JSON.stringify(avaliablehousecolours))
            for (let i = 0; i < houseColoursHolderOptions.length; i++) {
                // houseColoursHolderOptions[i].classList.add('disabled');
                // roofColoursHolderOptions[i].classList.add('disabled');
                var id = houseColoursHolderOptions[i].getAttribute('data-id');
                if(parsedavavaliablehousecolours.hasOwnProperty(id)){
                    houseColoursHolderOptions[i].classList.remove('disabled');
                }else{
                    houseColoursHolderOptions[i].classList.add('disabled');
                }
            }

            // trim-colours
            var trimColoursHolder = this.$el.querySelector(".trim-colours-holder");
            var trimColoursHolderOptions = this.$el.querySelectorAll(".trim-colours-holder .option");
            var parsedavaliabletrimcolours = JSON.parse(JSON.stringify(avaliabletrimcolours))
            for (let i = 0; i < trimColoursHolderOptions.length; i++) {
                // trimColoursHolderOptions[i].classList.add('disabled');
                var id = trimColoursHolderOptions[i].getAttribute('data-id');
                if(parsedavaliabletrimcolours.hasOwnProperty(id)){
                    trimColoursHolderOptions[i].classList.remove('disabled');
                }else{
                    trimColoursHolderOptions[i].classList.add('disabled');
                }
            }
        },
        getData(id, type, value){
            var me = document.querySelector('a[data-type="'+type +'"][data-slug="'+value +'"]');
            var card = me.querySelector(".card");
            var currentSelected = document.querySelector("."+type+"s-holder .card.selected");
            
            var selected = me.querySelector(".card.selected");
            if(selected){
                value = "";
                selected.classList.remove('selected');
            }else{
                if(currentSelected){
                    currentSelected.classList.remove('selected');
                }
                card.classList.add('selected');
            }

            axios({
                url: 'inspiration/design-your-roof/ajax?house=' + id + '&type=' + type + '&value=' + value ,
                method: 'GET',
                responseType: 'json',
                // NOTE: we need "Accept header" to make the webp convertion to work during ajax call
                headers: {
                    'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7'
                }
            }).then(response => {
                this.responseData = response.data;
                this.currentAsset = response.data.variant.variant.image;
                
                this.currentAssetID = response.data.variant.variant.imageid;
                this.moodboardID = 'variant_' + response.data.variant.variant.imageid;

                var options = response.data.options;
                var avaliablehousecolours = options.housecolours;
                var avaliableroofcolours = options.roofcolours;
                var avaliabletrimcolours = options.trimcolours;
                var avaliableprofiles = options.profiles;

                // profiles
                var profilesHolder = this.$el.querySelector(".profiles-holder");
                var profilesHolderOptions = this.$el.querySelectorAll(".profiles-holder .option");

                var parsedavaliableprofiles = JSON.parse(JSON.stringify(avaliableprofiles))
            
                for (let i = 0; i < profilesHolderOptions.length; i++) {
                    var id = profilesHolderOptions[i].getAttribute('data-id');
                    if(parsedavaliableprofiles.hasOwnProperty(id)){
                        profilesHolderOptions[i].classList.remove('disabled');
                    }else{
                        profilesHolderOptions[i].classList.add('disabled');
                    }
                    
                }

                // roof-colours
                var roofColoursHolder = this.$el.querySelector(".roof-colours-holder");
                var roofColoursHolderOptions = this.$el.querySelectorAll(".roof-colours-holder .option");

                var parsedavaliableroofcolours = JSON.parse(JSON.stringify(avaliableroofcolours))
            
                for (let i = 0; i < roofColoursHolderOptions.length; i++) {
                    // roofColoursHolderOptions[i].classList.add('disabled');
                    var id = roofColoursHolderOptions[i].getAttribute('data-id');
                    if(parsedavaliableroofcolours.hasOwnProperty(id)){
                        roofColoursHolderOptions[i].classList.remove('disabled');
                    }else{
                        roofColoursHolderOptions[i].classList.add('disabled');
                    }
                }


                // house-colours
                var houseColoursHolder = this.$el.querySelector(".house-colours-holder");
                var houseColoursHolderOptions = this.$el.querySelectorAll(".house-colours-holder .option");
                var parsedavavaliablehousecolours = JSON.parse(JSON.stringify(avaliablehousecolours))
                for (let i = 0; i < houseColoursHolderOptions.length; i++) {
                    // houseColoursHolderOptions[i].classList.add('disabled');
                    // roofColoursHolderOptions[i].classList.add('disabled');
                    var id = houseColoursHolderOptions[i].getAttribute('data-id');
                    if(parsedavavaliablehousecolours.hasOwnProperty(id)){
                        houseColoursHolderOptions[i].classList.remove('disabled');
                    }else{
                        houseColoursHolderOptions[i].classList.add('disabled');
                    }
                }

                // trim-colours
                var trimColoursHolder = this.$el.querySelector(".trim-colours-holder");
                var trimColoursHolderOptions = this.$el.querySelectorAll(".trim-colours-holder .option");
                var parsedavaliabletrimcolours = JSON.parse(JSON.stringify(avaliabletrimcolours))
                for (let i = 0; i < trimColoursHolderOptions.length; i++) {
                    // trimColoursHolderOptions[i].classList.add('disabled');
                    var id = trimColoursHolderOptions[i].getAttribute('data-id');
                    if(parsedavaliabletrimcolours.hasOwnProperty(id)){
                        trimColoursHolderOptions[i].classList.remove('disabled');
                    }else{
                        trimColoursHolderOptions[i].classList.add('disabled');
                    }
                }

                // set fav state
                this.moodboards = response.data.moodboards || [];
                this.setIsFavorite(response.data.variant.variant.imageid);
            })
            .catch(error => {
                console.log(error);
            })
        },
        async copyShare() {
            try {
                let shareLink = '';
                await axios.get(`inspiration/design-your-roof/share?house=${this.currentHouseID}`).then(response => shareLink = response.data.share);
                await navigator.clipboard.writeText(shareLink);

                const message = {
                    title: 'Share URL copy was successful',
                    text: 'Share URL copy was successful',
                }
                
                notify(message);
                this.appendtoNotification(message);
            } catch (err) {
                const message = {
                    title: 'Share URL copy was unsuccessful',
                    text: 'Share URL copy was unsuccessful',
                }
                
                notify(message);
                this.appendtoNotification(message);
            }
        },
        async emailShare() {
            try {
                let mailtoLink = '';
                await axios.get(`inspiration/design-your-roof/share?house=${this.currentHouseID}`).then(response => mailtoLink = response.data.mailto);
                window.location.href = mailtoLink;
            } catch (err) {
                const message = {
                    title: 'Unsuccessful',
                    text: 'Unsuccessful',
                }
                
                notify(message);
                this.appendtoNotification(message);
            }
        },
        resizeHandlerEvent() {},
        resizeHandler () {
            let rect = this.$refs.builderAnchor.getBoundingClientRect();
            let display = this.$refs.builderDisplay.getBoundingClientRect();
            let disAnchor = this.$refs.builderDisplayAnchor.getBoundingClientRect();

            const html = document.documentElement;
            const winSizes = {
                width : html.clientWidth,
                height : html.clientHeight
            }
            
            const content = (display.top + window.scrollY) + display.height;
            const limit = content - winSizes.height;

            let body = document.getElementsByTagName("BODY")[0];
            let limitTop = (body.classList.value.includes('profile-links--visible')) ? 61 : 0;

            let top = rect.top<=limitTop ? limitTop : rect.top;
            let bottom = (disAnchor.top-winSizes.height)>0 ? 0 : (disAnchor.top-winSizes.height) * (-1);

            this.builderBox = {
                top: top,
                left: rect.left,
                width: rect.width,
                bottom: bottom,
                class: 'fixed',
                wrapperClass: ''
            }

            clearTimeout(this.intervalID);
            this.intervalID = setTimeout(() => {
                this.detectButtonVisibility();
            }, 0);
        },
        onImgLoad() {
            this.resizeHandler();
        },
        slidePrev(id) {
            const elem = document.getElementById(id);
            elem.scrollBy(elem.getBoundingClientRect().width/1.5 * (-1), 0);
        },
        slideNext(id) {
            const elem = document.getElementById(id);
            elem.scrollBy(elem.getBoundingClientRect().width/1.5, 0);
        },
        slideOnScroll(id) {
            const slideBuffer = 10;
            const elem = typeof id === 'string' ? document.getElementById(id) : id;

            if (!elem) return;

            const isScrolling = elem.querySelector('.items').offsetWidth > elem.offsetWidth;

            elem.parentNode.parentNode.classList.add('no-scroll');
            if(isScrolling){
                elem.parentNode.parentNode.classList.remove('no-scroll');
            }

            if(isScrolling && elem.scrollLeft >= (elem.querySelector('.items').offsetWidth - elem.offsetWidth - slideBuffer)) {
                elem.parentNode.parentNode.classList.add('is-max');
                elem.parentNode.parentNode.classList.remove('is-min');
            } else if(isScrolling && elem.scrollLeft <= slideBuffer) {
                elem.parentNode.parentNode.classList.remove('is-max');
                elem.parentNode.parentNode.classList.add('is-min');
            } else {
                elem.parentNode.parentNode.classList.remove('is-max');
                elem.parentNode.parentNode.classList.remove('is-min');
                elem.parentNode.parentNode.classList.add('no-scroll');
            }
        },
        detectButtonVisibility() {
            let status = true;
            const slideItems = document.getElementsByClassName('color-option-scroll');

            [...slideItems].forEach(elem => {
                if (elem) {
                    const itemOffsetWidth = elem.querySelector('.items')?.offsetWidth || 0

                    if (itemOffsetWidth <= 0) {
                        status = false;
                    }

                    const nextButton = elem?.parentNode?.parentNode?.querySelector('.filter-wrapper--next');
                    if (itemOffsetWidth <= elem.offsetWidth) {
                        nextButton.classList.add('hidden');
                    } else {
                        nextButton.classList.remove('hidden');
                    }

                    this.slideOnScroll(elem);
                }
            });

            return status;
        }
    },
    created() {
        const app = this;
        app.resizeHandlerEvent = debounce(function(){
            app.resizeHandler();
        }, 250);
        window.addEventListener("resize", this.resizeHandlerEvent);
        window.addEventListener("scroll", this.resizeHandler);
    },
    mounted() {
        const app = this;
        this.resizeHandler();

        this.currentAsset =  this.data.result.variant.image;
        this.currentAssetID = this.data.result.variant.id;
        this.moodboardID = 'variant_' + this.data.result.variant.id;
        this.moodboards = this.data.moodboards || [];
        
        this.currentTitle = this.data.result.variant.title;
        this.currentSummary = this.data.result.variant.summary;
        this.currentContent = this.data.result.variant.content;

        this.currentHouseID =  this.data.result.activeHouse;
        this.currentProfile = this.data.result.activeProfile;
        
        var profile = document.querySelector('a[data-type="profile"][data-slug="'+this.currentProfile +'"]');
        if(profile!==null){
            var card = profile.querySelector(".card");
                card.classList.add('selected');
        }
        
        var RoofColour = document.querySelector('a[data-type="roof-colour"][data-slug="'+this.currentRoofColour +'"]');
        if(RoofColour!==null){
            var card = RoofColour.querySelector(".card");
                card.classList.add('selected');
        }
        
        var houseColour = document.querySelector('a[data-type="house-colour"][data-slug="'+this.currentHouseColour +'"]');
        if(houseColour!==null){
            var card = houseColour.querySelector(".card");
                card.classList.add('selected');
        }
    
        var trimColour = document.querySelector('a[data-type="trim-colour"][data-slug="'+this.currentTrimColour +'"]');
        if(trimColour!==null){
            var card = trimColour.querySelector(".card");
                card.classList.add('selected');
        }

        this.currentRoofColour = this.data.result.activeRoofColour;
        this.currentHouseColour = this.data.result.activeHouseColour;
        this.currentTrimColour = this.data.result.activeTrimColour;
        this.currentAvaliableOptions = this.data.result.options;

        this.setOptions();

        window.addEventListener('resize', () => {
            clearTimeout(app.intervalID);
            app.intervalID = setTimeout(() => {
                app.detectButtonVisibility();
            }, 250);
        });

        // set state of fav icon
        this.setIsFavorite(this.data.result.variant.id);
    },
};
</script>

<style lang="scss" scoped>
@import "../../scss/abstracts/variables";
@import "../../scss/abstracts/mixins";

.button {
    display: flex;
    justify-content: center;
    align-items: center;
}

.visualiser-main {
    margin-top: 130px;
    position: relative;

    @media (max-width:767px) {
        margin-top: 80px;
    }

    .breadcrumb {
        padding: 24px 0;

        @media #{$md} {
            padding: 0;
        }

        & > a {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 12px;
            font-style: normal;
            font-weight: 300;
            line-height: 25px;
        }

        .icon {
            display: flex;
        }
    }

    .header {
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding-top: 18px;
        padding-bottom: 18px;

        @media #{$md} {
            gap: 16px;
            margin-top: 40px;
            padding-top: 21px;
            padding-bottom: 21px;
        }
    }

    .label-wrapper {
        border-top: 1px solid black;
        display: flex;
        justify-content: flex-end;
        margin-top: 18px;
        padding-top: 25px;
        padding-bottom: 15px;

        @media #{$md} {
            margin-top: 28px;
            padding-top: 45px;
            padding-bottom: 0;
        }

        .label {
            display: grid;
            grid-template-columns: 7fr 5fr;
            width: 100%;
            
            @media #{$md} {
                width: 60%;
            }

            @media #{$lg} {
                width: 70%;
            }

            .label--title {
                font-family: $font-primary-med;
                font-size: 24px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
            }

            .label--summary {
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 26px;
                margin: 8px 0 0 0;
            }
    
            .wysiwyg-content {
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                align-items: flex-end;
    
                > :first-child {
                    margin-top: 0;
                }
    
                > :last-child {
                    margin-bottom: 0;
                }
            }
        }
    }

    .builder {
        display: flex;
        flex-direction: row;
        padding: 24px 0 20px;
        min-height: 1000px;

        @media (max-width:767px) {
            display: block;
            padding-top: 0;
        }

        .builder-select {
            width: 30%;
            padding: 0 3rem 0 0;

            @media (max-width:991px) {
                width: 40%;
            }

            @media (max-width:767px) {
                width: 100%;
                padding: 0;
            }

            .accordion-title {
                font-family: $font-primary-med;
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                margin: 0;
            }

            .accordion-description {
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                margin: 0;
                margin-top: 4px;
            }
        }

        .builder-display {
            width: 70%;

            @media (max-width:991px) {
                width: 60%;
            }
            
            @media (max-width:767px) {
                width: 100%;
            }

            .preview {
                position: relative;

                @media (max-width:767px) {
                    display: none;
                }

                img {
                    width: 100%;
                    display: block;
                    position: relative;
                    z-index: 2;
                }
            }

            .action-block {
                border-bottom: 1px solid #000;
                display: flex;
                flex-direction: column;
                gap: 24px;
                padding-top: 40px;
                padding-bottom: 40px;

                &:last-child {
                    border-bottom: 0;
                }

                h2 {
                    font-size: 30px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                }

                p {
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 26px;
                }

                .button {
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                    padding: 12px 24px;

                    @media #{$md} {
                        align-self: flex-start;
                    }
                }

                .wysiwyg-content {
                    > :first-child {
                        margin-top: 0;
                    }

                    > :last-child {
                        margin-bottom: 0;
                    }
                }
            }

            .action-share {
                display: flex;
                gap: 24px;

                .button {
                    width: 100%;

                    @media #{$md} {
                        width: auto;
                    }
                }
            }
        }

        .builder-preview-mobile {
            display: none;

            @media (max-width:767px) {
                position: sticky;
                top: 0;
                z-index: 200;
                display: block;
                margin-left: (($grid-col-base/2) + $grid-gutter-base) * (-1);
                margin-right: (($grid-col-base/2) + $grid-gutter-base) * (-1);

                img {
                    display: block;
                    width: 100%;
                    position: relative;
                    z-index: 1;
                }
            }

            @media (max-width:575px) {
                margin-left: -1.5em;
                margin-right: -1.5em;
            }
        }

        .fav-wrapper {
            position: absolute;
            z-index: 10;
            bottom: 10px;
            right: 10px;

            .fav {
                position: absolute;
                bottom: 10px;
                right: 10px;
                z-index: 10;
                display: block;
                width: 37px;
                height: 37px;
                background-color: rgba($brand-black, 0.2);
                background-image: url('#{$dir-images}icons/fav.svg');
                background-position: 9px 13px;
                background-size: 19px 16px;
                background-repeat: no-repeat;
                border-radius: 50%;
                cursor: pointer;
                transition: all 300ms;

                &.remove-fav {
                    display: none;
                    background-image: url('#{$dir-images}icons/fav-active.svg');

                    &.selected {
                        display: block;
        
                        &.remove {
                            background-size: 15px 15px;
                            background-position: center;
                            background-image: url('#{$dir-images}icons/close-white.svg');
                        }
                    }
                }
    
                &.add-fav {
                    display: block;
                    &.selected {
                        display: none;    
                    }
                }
    
                &.selected {
                    &.remove {
                        background-image: url('#{$dir-images}icons/close-white.svg');
                    }
                } 
            }
        }
    }

    .selections {
        display: flex;
        flex-wrap: wrap;

        .color-option-wrapper {
            display: flex;
            margin-bottom: 20px;
            position: relative;
            width: 100%;

            .filter-wrapper--hide-scroll {
                width: 100%;

                &::before,
                &::after {
                    content: "";
                    background: linear-gradient(90deg, rgba(255, 254, 250, 0) 0%, #fffefa 50%, #fffefa 100%);
                    pointer-events: none;
                    height: 100%;
                    width: 90px;
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 99;
                }

                &::before {
                    right: auto;
                    left: 0;
                    transform: translateY(-50%) rotate(180deg);
                }
            }
            .color-option-scroll {
                display: flex;
                overflow-x: auto;
                scroll-behavior: smooth;
                width: 100%;
            }

            .items {
                display: flex;
                flex-shrink: 0;
                column-gap: 12px;
            }

            .color.option {
                display: flex;
                flex-direction: column;
                align-items: center;
                width: min-content;
            }

            .color-name {
                font-family: $font-primary-med;
                font-size: 12px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                margin-top: 10px;
            }

            .color-group {
                font-family: $font-primary-light;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                margin-top: auto;
                word-break: keep-all;
                white-space: nowrap;
            }

            .filter-wrapper--prev,
            .filter-wrapper--next {
                display: flex;
                top: 0;
            }

            // hide next / prev button if reach end of the scroll
            &.no-scroll {
                .filter-wrapper--hide-scroll {
                    &::before,
                    &::after { 
                        display: none;
                    }
                }

                .filter-wrapper--prev,
                .filter-wrapper--next {
                    display: none;
                }
            }
            &.is-min {
                .filter-wrapper--hide-scroll {
                    &::before {
                        display: none;
                    }
                }
                .filter-wrapper--prev {
                    display: none;
                }
            }

            &.is-max {
                .filter-wrapper--hide-scroll {
                    &::after {
                        display: none;
                    }
                }
                .filter-wrapper--next {
                    display: none;
                }
            }
        }

        .option {
            width: 50px;
            text-align: center;

            &:last-child {
                margin-right: 0;
            }

            &.disabled {
                pointer-events: none;
                cursor: not-allowed;
                color: gray;
                background-color: red;
                a {
                    background-color: red;
                }
            }

            .icon {
                position: relative;
                border-radius: 50%;
                margin: 1rem auto;
                background-color: transparent;
                width: 50px;
                height: 50px;
                // margin-left: 0;

                &.selected {
                    &::before {
                        content: "";
                        display: block;
                        width: 30px;
                        height: 30px;
                        border-radius: 50%;
                        background-color: $color-primary;
                        background-image: url('#{$dir-images}icons/tick.svg');
                        background-repeat: no-repeat;
                        background-position: center;
                        background-size: 15px;
                        position: absolute;
                        top: calc(50% - 15px);
                        left: calc(50% - 15px);
                        pointer-events: none;
                    }
                
                }
            }

            .hovertitle {
                @include font-size(16);
                font-family: $font-primary-med;
            }
        }

        &.profiles-holder {
            .option {
                width: 100px;
                padding-left: 5px;
                padding-right: 5px;
                margin-right: 0;
            }
        }

        &.section-colour {
            margin-right: -1.5rem;
            width: 100%;
        }
    }

    @media (min-width: 768px) {
        .selections .color-option-wrapper {
            .color.option {
                margin-right: 0;
                max-width: 75px;
                width: 100%;
            }

            .items {
                flex-wrap: wrap;
                justify-content: start;
                row-gap: 10px;
                width: 100%;
            }
        }
    }

    .accordion.accordion--small .accordion-item {
        // padding: 1.5rem 0 1.5rem 0;
    }


}
</style>


<style lang="scss">
@import "../../scss/abstracts/variables";
@import "../../scss/abstracts/mixins";

body {
    &.RoofVisualiserPage {
        overflow-x: hidden;
    }

    &.profile-links--visible {
        overflow-x: hidden;

        .visualiser-main {
            margin-top: 191px;

            .builder .builder-preview-mobile {
                @media (max-width:767px) {
                    top: 61px;
                }
            }
        }
    }
}

.visualiser-main {
    /* prevent wysiwyg image being cropped */
    .label .wysiwyg-content {
        p {
            line-height: 0;
            overflow: hidden;
        }

        img {
            height: auto;
            max-height: 100px;
            width: 100%;
        }
    }

    .accordion.accordion--small .accordion-item {
        .accordion-trigger {
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;

            &::before,
            &::after {
                top: unset;
            }

            @media #{$below-md} {
                padding-top: 16px;
                padding-bottom: 16px;
            }
        }
    }

    .accordion--small {
        .accordion-item {
            &:first-child {
                border-top: none;
            }
        }
        
        .color.option {
            .card {
                box-shadow: none !important;
                margin-bottom: 1rem;

                .colour-sample-selector {
                    display: none;
                }

                .colour-circle {
                    margin-bottom: 0;

                    &::before {
                        background-size: 15px;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 30px;
                        height: 30px;
                    }
                }

                .info {
                    position: absolute;
                    z-index: 10;
                    background: $brand-black;
                    top: 50%;
                    left: 40px;
                    transform: translateY(-50%);
                    pointer-events: none;
                    color: #fff;
                    // margin-left: 12px;
                    width: auto;

                    .hovername {
                        white-space: nowrap;
                        margin: 0;
                        min-height: 22px;
                        // font-size: 12px;
                        @include font-size(12);
                        padding: 3px 10px 3px 5px;

                        &::before {
                            content: "";
                            display: block;
                            position: absolute;
                            width: 0;
                            height: 0;
                            border: 11px solid transparent;
                            border-right-color: $brand-black;
                            border-right-width: 7px;
                            border-left: 0;
                            left: -7px;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                }

                &:hover {
                    .info {
                        .hovername {
                            display: block;
                            opacity: 1;
                            visibility: visible;
                        }
                    }
                }

                &.right-side {
                    .info {
                        left: auto;
                        right: 40px;

                        .hovername {
                            padding: 3px 5px 3px 10px;
                            
                            &::before {
                                border: 11px solid transparent;
                                border-left-color: $brand-black;
                                border-left-width: 7px;
                                border-right: 0;
                                left: auto;
                                right: -7px;
                            }
                        }
                    }
                }
            }

            
        }

        .accordion-content.active {
            overflow: visible;
        }

        .colour-card--visualiser{
            .colour-circle {
                margin-left: 0;
                margin-right: 0;
            }
            &.selected .colour-circle::before {
                width: 30px;
                height: 30px;
                background-size: 15px;
                top: calc(50% - 15px);
                left: calc(50% - 15px);
            }
        }
    }
}

@media(min-width: 768px) {
    .builder-select--sizer {
        height: 0;
    }
    .builder-select--inner {
        overflow-x: hidden;
        overflow-y: auto;

        &.fixed {
            position: fixed;
            top: var(--builder-top);
            left: var(--builder-left);
            bottom: var(--builder-bottom);
            width: var(--builder-width);
        }

        &.position-bottom {
            height: 100vh;
        }
    }

    
    .browser--webkit-windows {
        .builder-select--inner {

            &::-webkit-scrollbar {
                -webkit-appearance: none;
            }

            &::-webkit-scrollbar:vertical {
                width: 11px;
            }

            &::-webkit-scrollbar:horizontal {
                height: 11px;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 8px;
                border: 2px solid white;
                background-color: rgba(0, 0, 0, .5);
            }

            &::-webkit-scrollbar-track { 
                background-color: #fff; 
                border-radius: 8px; 
            }
        }
    }

    .align-content-bottom {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
}
</style>